export type ApartmentFeaturesInfo = {
  [key: string]: {
    iconName: string;
    label: string;
  };
};

export const APARTMENT_FEATURES_INFO: ApartmentFeaturesInfo = {
  rooms: {
    iconName: 'plan',
    label: 'card-apartment.feature.room',
  },
  floor: {
    iconName: 'stairs',
    label: 'card-apartment.feature.floor',
  },
  surface: {
    iconName: 'surface',
    label: 'card-apartment.feature.surface',
  },
  buildingName: {
    iconName: 'office-building',
    label: 'card-apartment.feature.building-name',
  },
  sharedBathroom: {
    iconName: 'bathroom',
    label: 'card-apartment.feature.shared-bathroom',
  },
  privateBathroom: {
    iconName: 'bathroom',
    label: 'card-apartment.feature.private-bathroom',
  },
};

export const ORDERED_FEATURE_KEYS = ['rooms', 'privateBathroom', 'sharedBathroom', 'floor', 'surface', 'buildingName'] as const;
